import URI from 'urijs';

import type { Input } from 'components/messageloaders/Types';
import useForwardersConfiguration from 'forwarder/wizard/select-forwarder-step/hooks/useForwardersConfiguration';
import AppConfig from 'util/AppConfig';

// eslint-disable-next-line import/prefer-default-export
export const useConfiguration = (input?: Input) => {
  const { data: configurationData } = useForwardersConfiguration();
  let configuration: { [key: string]: string } = {};

  const graylogServerHostname =
    configurationData?.server_hostname || new URI(AppConfig.gl2ServerUrl()).hostname() || window.location.hostname;
  configuration.forwarder_server_hostname = AppConfig.isCloud()
    ? `ingest-${graylogServerHostname}`
    : graylogServerHostname;
  configuration.forwarder_grpc_api_token = '<your api token>';

  if (input) {
    const {
      forwarder_message_transmission_port: messageTransmissionPort,
      forwarder_grpc_enable_tls: enableTls,
      forwarder_grpc_tls_trust_chain_cert_file: trustChainCertFile,
      forwarder_configuration_port: configurationPort,
    } = input.attributes;

    configuration = {
      ...configuration,
      forwarder_configuration_port: configurationPort,
      forwarder_message_transmission_port: messageTransmissionPort,
      forwarder_grpc_enable_tls: configurationData?.grpc_enable_tls ?? enableTls,
    };

    if (enableTls && trustChainCertFile) {
      const certFilename = trustChainCertFile.split(/[\\|/]/).pop();
      configuration.forwarder_grpc_tls_trust_chain_cert_file = `<path to ${certFilename || 'your cert file'}>`;
    }
  }

  return [configuration];
};
